module.exports = __webpack_public_path__ + "static/img/swiperadmin1.fa22861.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/swiperadmin1.png
// module id = ZlFG
// module chunks = 1